module.exports = __webpack_public_path__ + "img/Grizzly-Banner.8fa49d04.png";